// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-module--root--11CHY","right":"Footer-module--right--1Ab1b","logo":"Footer-module--logo--3Uan7","contact":"Footer-module--contact--27cin"};